import React from 'react';
import { colors } from '../../config/styles';
import KubitTooltip from '../KubitTooltip';
import { IconWrapper, SvgIcon } from '../Icon';

interface IProps {
  errorMessage: string;
}

const FieldErrorHint = ({ errorMessage }: IProps) => {
  return (
    <KubitTooltip content={errorMessage} placement="right" noOpenDelay={true}>
      <IconWrapper size={16}>
        <SvgIcon
          name="triangle-exclamation"
          width={16}
          height={13}
          customFill={colors.mainError}
        />
      </IconWrapper>
    </KubitTooltip>
  );
};

export default FieldErrorHint;
